import React from 'react';
import ImageBlurFallback from '../../Components/ImageBlurFallback';

import { CLIENT_URL_IMAGE } from '../../config.local';

const CollaboratedCompanies = ({ companies }) => {
  return companies && companies.length ? (
    <div className="th-companies-container">
      <span className="th-companies-heading">
        Collaborated Companies
      </span>
      <div className="th-companies-images-container">
        {companies.map(company => (
          <ImageBlurFallback
            className="th-companies-imagebox"
            src={`${CLIENT_URL_IMAGE}${company.logoUrl}`}
            alt={company.name}
            key={company.id}
          />
        ))}
      </div>
    </div>
  ) : null;
};
export default CollaboratedCompanies;



// WEBPACK FOOTER //
// ./src/Pages/ThreeHundred/CollaboratedCompanies.js